import { combineReducers } from "redux";
import theme from "./slices/themeSlice";
import auth from "./slices/authSlice";
import user from "./slices/userSlice";
import order from "./slices/orderSlice";
import product from "./slices/productSlice";

const rootReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    auth,
    user,
    order,
    product,
    ...asyncReducers,
  });
  return combinedReducer(state, action);
};

export default rootReducer;
